module.exports = __webpack_public_path__ + "media/images/flags/SD-13129d73abb8bba6e62e15d3dd670188.svg";